// Aktuelle Geschwindigkeit aus einem GPS-Fix.
// GeolocationCoordinates.speed ist in m/s und kann null/NaN sein (Stillstand
// oder Gerät liefert keine Geschwindigkeit). Wir rechnen in km/h um.

/** km/h aus einem GPS-Fix, oder null wenn keine valide Geschwindigkeit. */
export function kmhFromCoords(
  pos: GeolocationCoordinates | null | undefined,
): number | null {
  const s = pos?.speed;
  if (typeof s !== 'number' || !Number.isFinite(s) || s < 0) return null;
  return s * 3.6;
}

/** Kompakte km/h-Anzeige. null → "–". <10 km/h eine Nachkommastelle. */
export function formatKmh(kmh: number | null): string {
  if (kmh == null) return '–';
  return kmh < 10 ? kmh.toFixed(1) : Math.round(kmh).toString();
}
